module.exports = __webpack_public_path__ + "media/images/flags/nz-0dcf8cf746e1d65a4528f729ab25e8c5.svg";